import React from 'react';
import { Result } from 'antd';
import useUnsubscribeToken from '../../hooks/useUnsubscribeToken';
import { useGetUnsubscriptionStatus } from '../../query/unsubscribe';
import moment from 'moment';

export default function UnsubscriptionSuccess() {
  const unsubscribeToken = useUnsubscribeToken();
  const { data: unsubscriptionStatus } = useGetUnsubscriptionStatus(
    unsubscribeToken,
  );
  const pauseTerm = unsubscriptionStatus?.isPaused
    ? ` for ${moment(unsubscriptionStatus.pauseUntil).diff(
        moment().subtract(1, 'day'),
        'month',
      )} months`
    : '';
  return (
    <div
      className="flex items-center w-full"
      style={{ flexDirection: 'column' }}
    >
      <Result
        status="success"
        style={{ paddingBottom: 20 }}
        subTitle={
          <div style={{ maxWidth: 700, marginTop: 10 }}>
            You will no longer receive email marketing from this list{pauseTerm}
            . However, please note that important transactional or
            account-related emails may still be sent to you.
          </div>
        }
        title={`${
          unsubscriptionStatus?.isPaused ? 'Paused' : 'Unsubscribed'
        } Successfully`}
      />
    </div>
  );
}
